import React from 'react';
import { withRouter } from 'react-router-dom';

import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';

import { withStyles } from '@material-ui/core/styles';

import logoHeader from '../../../Resources/Logo Header.gif';

const styles = theme => ({
    toolbar: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        height: '10vh'
    },
    logo: {
        flex: 1,
    },
    toolbarSecondary: {
        justifyContent: 'flex-start',
        overflowX: 'auto',
    },
    link: {
        padding: theme.spacing(1),
        flexShrink: 0,
        fontWeight: 'bold'
    },
    linkButton: {
        padding: theme.spacing(1),
        flexShrink: 0,
        fontWeight: 'bold',
        textAlign: 'center',
        width: '150px'
    }
})

class NavComponent extends React.Component {

    goLogout = () => {
        sessionStorage.removeItem('status')
        this.props.history.push({
            pathname: '/'
        })
    }

    goHome = () => {
        this.props.history.push({
            pathname: '/Home'
        })
    }

    goListing = () => {
        this.props.history.push({
            pathname: '/Authed/Listing'
        })
    }

    goDataview = () => {
        this.props.history.push({
            pathname: '/Dataview'
        })
    }

    goUserView = () => {
        this.props.history.push({
            pathname: '/UserView'
        })
    }

    render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                <Toolbar className={classes.toolbar}>
                    <img src={logoHeader} alt="logo" style={{ height: '8vh', objectFit: 'contain' }} className={classes.logo} />
                    <Button variant="outlined" size="small" onClick={this.goLogout}>
                        Logout
                    </Button>
                </Toolbar>

                <Toolbar component="nav" variant="dense" className={classes.toolbarSecondary}>
                    <Button className={classes.linkButton}
                    color="inherit" component={Link}
                        onClick={this.goHome}>
                        Home
                    </Button>
                    <Button className={classes.linkButton}
                    color="inherit" component={Link}
                        onClick={this.goListing}>
                        Listing
                    </Button>
                    <Button className={classes.linkButton}
                    color="inherit" component={Link}
                        onClick={this.goDataview}>
                        Data View
                    </Button>
                    <Button className={classes.linkButton}
                    color="inherit" component={Link}
                        onClick={this.goUserView}>
                        Manage User
                    </Button>
                </Toolbar>
            </React.Fragment>
        )
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(NavComponent));